import React from 'react';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import locales from '../../locales/LocalesManager';
import { changeMood, updateCurrentSlideThumbnail, updateShapePosition } from '../../actions/CurrentSlideActions';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import appParameters from '../../components/utils/AppParameters';
import platformDetection from '../utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import modeType from '../../constants/ModeConstants';
import { changeContextMode } from '../../actions/MenuActions';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var caption;

        if (this.props.type == 'background')
            caption = locales.getCaption('Mode', 'shapeMenu');
        else
            caption = locales.getCaption('Moods', 'shapeMenu');

        var closeButtonStyle = {
            position: 'absolute',
            right: 28,
            top: 4,
            width: 22,
            height: 22,
            cursor: 'pointer',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            background: 'none',
            borderStyle: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            right: 3,
            cursor: 'pointer'
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{caption}</span>
                <button id="firstFocusableObject" style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeMood();
    },
    onClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeMood();
    },
    changeMood() {
        const shapeModel = this.getCurrentTarget();

        if (!shapeModel)
            return;

        saveManager.isContentChanged(true);

        if (this.props.value != shapeModel.frameLabel) {
            this.props.dispatch(changeMood(this.props.shapeModel.uuid, this.props.value));
            audioEditorUtils.addActionToHistory();
            this.updateThumbnail();

            // hack for refreshing characters on IOS after changing mood
            if (platformDetection.isIOS() == true)
                this.refreshShape();
        }
    },
    refreshShape() {
        saveManager.isContentChanged(true);
        const shapeModel = this.getCurrentTarget();
        this.props.dispatch(updateShapePosition(this.props.shapeModel.uuid, shapeModel.x + 1, shapeModel.y));
        setTimeout(this.revertPosition, 10);
    },
    revertPosition() {
        const shapeModel = this.getCurrentTarget();

        saveManager.isContentChanged(true);

        if (shapeModel)
            this.props.dispatch(updateShapePosition(this.props.shapeModel.uuid, shapeModel.x - 1, shapeModel.y));
    },
    updateThumbnail() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    getCurrentTarget () {
        const state = storeManager.getState();
        const uuid = this.props.shapeModel.uuid;
        const shapes = state.currentSlide.model.content;
        var i;
        var target;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].uuid == uuid) {
                target = shapes[i];
                break;
            }
        }

        return target;
    },
    getSrc () {
        return appParameters.SVG_URL() + `${this.props.shapeModel.logicalName}_${this.props.value}.svg`;
    },
    render() {
        const width = properties.MOOD_ITEM_SIZE;
        const textHeight = 20;
        const height = width * 3/4 + textHeight;

        const buttonStyle = {
            position: 'absolute',
            top: this.props.index * height + (this.props.index + 1) * properties.MOOD_ITEM_GAP,
            left: (this.props.accordionWidth - properties.MOOD_ITEM_SIZE) / 2,
            width: width,
            height: height,
            background: '#f3f3f3',
            cursor: 'default',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const topOffset = (this.props.shapeModel && this.props.shapeModel.type == 'Background') ? 0 : 10;
        const imageStyle = {
            width: properties.MOOD_ITEM_SIZE,
            height: properties.MOOD_ITEM_SIZE * 3/4 - 2 * topOffset,
            top: topOffset,
            left: 0,
            position: 'absolute'
        };

        var borderColor;

        if (this.state.isOver == true)
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            borderColor = properties.SLIDE_VIEWER_BACKGROUND;

        const borderWidth = 2;

        const frameStyle = {
            width: width - 2 * borderWidth,
            height: height - 2 * borderWidth,
            borderWidth: borderWidth,
            borderStyle: 'solid',
            borderColor: borderColor,
            position: 'absolute',
            top: 0,
            cursor: 'default'
        };

        const textPadding = 3;

        const titleStyle = {
            fontSize: 15,
            height: textHeight,
            width: width - 2 * textPadding,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            textAlign: 'center',
            position: 'absolute',
            left: textPadding,
            bottom: 0
        };

        var checkVisibility;
        const shapeModel = this.getCurrentTarget();

        if (shapeModel && this.props.value == shapeModel.frameLabel)
            checkVisibility = 'block';
        else
            checkVisibility = 'none';

        const selectionStyle = {
            position: 'absolute',
            top: 5,
            right: 8,
            color: 'black',
            display: checkVisibility
        };

        const moodTranslation = locales.getMoodsCaption(this.props.value);

        var idValue;

        if (this.props.index == this.props.lastItem)
            idValue = 'moodsLastItem';

        return (
            <button id={idValue} aria-label={moodTranslation} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp} onClick={this.onClick}>
                <img alt='' aria-hidden='true' style={imageStyle} src={this.getSrc()}/>
                <i style={selectionStyle} className='fa fa-check'></i>
                <span style={titleStyle}>{moodTranslation}</span>
                <div style={frameStyle}/>
            </button>
        );
    }
});

export const MoodsMenu = React.createClass({
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObject');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    getShapeModel () {
        const state = storeManager.getState();
        var shapeModel;

        if (this.props.type == 'background')
            shapeModel = state.currentSlide.model.content[0];
        else
            shapeModel = this.props.contextTarget;

        return shapeModel;
    },
    getMoods () {
        const shapeModel = this.getShapeModel();

        if (shapeModel.moods)
            return shapeModel.moods;
        else
            return [];
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        setTimeout(this.refreshView, 10);
    },
    refreshView () {
        this.forceUpdate();
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth || this.props.type != newProps.type || this.props.contextTarget != newProps.contextTarget || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight)
            return true;
        else
            return false;
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var elements = [];
        const moods = this.getMoods();
        const shapeModel = this.getShapeModel();
        var i;

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT - 10;
        componentProperties.top = properties.CLIPART_BUTTON_HEIGHT;
        componentProperties.displayState = 'block';

        for (i=0; i<moods.length; i++) {
            elements.push(<Button accordionWidth={this.props.accordionWidth} index={i} key={'moods' + moods[i]} value={moods[i]} lastItem={moods.length - 1} shapeModel={shapeModel} dispatch={this.props.dispatch}/>);
        }

        componentProperties.elements = elements;
        componentProperties.scrollHeight = elements.length * 154 + 20;

        return (
            <div id="moodsMenu" style={menuStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                <Title accordionWidth={this.props.accordionWidth} type={this.props.type}/>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/MoodsMenu.js
 **/